/**
 * Hostname helpers shared by the universal-template classification UI and the public form.
 * Must match the backend `normalizeHostname` in leadrs-back/src/controller/formTemplateController.ts
 * so domain-level industry overrides (keyed by normalized hostname) resolve consistently.
 */

/** Lowercase, trim, strip a leading `www.` — nothing else. */
export function normalizeHostname(hostname: string): string {
    return (hostname || '').trim().toLowerCase().replace(/^www\./, '');
}

/**
 * Canonical landing-page form — MUST match the backend `canonicalizePageUrl`
 * (leadrs-back/src/store/sitemapCrawler.ts): a real http(s) URL becomes `origin + pathname`
 * lowercased (no query/hash); anything else (free text the copy modal still allows) is returned
 * trimmed, unchanged.
 */
export function canonicalizeLandingPage(input: string): string {
    const raw = (input || '').trim();
    if (!raw) return '';
    try {
        const u = new URL(raw);
        if (u.protocol !== 'http:' && u.protocol !== 'https:') return raw;
        return `${u.origin}${u.pathname}`.toLowerCase();
    } catch {
        return raw;
    }
}

/**
 * Normalized hostname of a URL. Tolerates bare hosts / free text (the copy modal lets sellers
 * type "page-accueil" or "mon-site.fr"): falls back to treating the input itself as the host.
 * Returns '' only for empty input.
 */
export function hostnameFromUrl(url: string): string {
    const raw = (url || '').trim();
    if (!raw) return '';
    try {
        const withProtocol = /^https?:\/\//i.test(raw) ? raw : `https://${raw}`;
        return normalizeHostname(new URL(withProtocol).hostname);
    } catch {
        return normalizeHostname(raw);
    }
}
